import { render, staticRenderFns } from "./takeInVue.vue?vue&type=template&id=6f3e4974"
import script from "./takeInVue.vue?vue&type=script&lang=js"
export * from "./takeInVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports